const storageKey = (userId: number): string => `cfResumeDomain:${userId}`;

export const readRememberedDomain = (userId: number): string | null =>
  window.localStorage.getItem(storageKey(userId));

export const rememberProbedDomain = (userId: number, domain: string): void => {
  window.localStorage.setItem(storageKey(userId), domain);
};

export const forgetProbedDomain = (userId: number): void => {
  window.localStorage.removeItem(storageKey(userId));
};
